$(function(){
  var slideNum = $('.collectionWrap_list').length;
  if(slideNum > 1) {
    $('.collectionWrap_list').addClass('collectionSlideItems');
    $('<div class="arrowWrap"><span class="prev"><img src="https://cdn.shopify.com/s/files/1/0668/0467/8929/files/collection-arrow.svg?v=1675666454" alt="prev"></span><span class="next active"><img src="https://cdn.shopify.com/s/files/1/0668/0467/8929/files/collection-arrow.svg?v=1675666454" alt="next"></span></div>').prependTo('.collectionWrap');
  };
  var listLength = $('.collectionWrap_list').length;
  var num = 1;
  $('.collectionWrap span').on('click',function() {
    $('.collectionWrap_list').css('display','none');
    if($(this).hasClass('next')) {
      num = num + 1;
      $('.collectionWrap .prev').addClass('active');
      if(num == 2) {
        $('.collectionWrap_list:nth-of-type(3)').fadeIn("slow");
      } else if (num == 3) {
        $('.collectionWrap_list:nth-of-type(4)').fadeIn("slow");
        $(this).removeClass('active');
      }
      if(num == listLength) {
        $(this).removeClass('active');
      }
    } else if($(this).hasClass('prev')) {
      num = num - 1;
      if(num == 1) {
        $('.collectionWrap_list:nth-of-type(2)').fadeIn("slow");
        $(this).removeClass('active');
      } else if (num == 2) {
        $('.collectionWrap_list:nth-of-type(3)').fadeIn("slow");
        $('.collectionWrap .next').addClass('active');
      }
      if(num == listLength - 1) {
        $('.collectionWrap .next').addClass('active');
      }
    };
  });
  
  if($('.collectionWrap').length > 1){
     $('.collectionWrap').each(function(){
       if($(this).find('.collectionWrap_list').length == 1){
         $(this).find('.arrowWrap').hide();
       }
     });
  }
});


